import {UserAccess, UserRole} from './types';

export function getUserAccess(entity: any, {ownerId, userId}: {ownerId: number; userId: number}): UserAccess {
  return ownerId === userId
    ? UserAccess.Creator
    : entity.can_update_basic || entity.canUpdateBasic
      ? UserAccess.Editor
      : entity.can_view || entity.canView
        ? UserAccess.Viewer
        : UserAccess.None;
}

// Roles no longer offered as assignable but still present on legacy grants; kept
// editable so admins can migrate off them, never newly assigned.
export const DEPRECATED_USER_ROLES: ReadonlySet<string> = new Set<string>([UserRole.Messenger]);

export function isDeprecatedUserRole(roleName: string | null | undefined): boolean {
  return !!roleName && DEPRECATED_USER_ROLES.has(roleName.toLowerCase());
}
